exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".drag-item-container {\n  cursor: move;\n  width: 200px;\n  height: 45px;\n  margin-bottom: 8px;\n  padding: 3px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/DragItem/DragItem.scss
// module id = 533
// module chunks = 0